// deps
import React, { ReactElement, memo, ReactNode } from "react";

//components
import { BackIcon } from "@core-ui/components/back-icon";

// styles
import { Container, ContainerButton, ContainerContent } from "./styles";
import { useTheme } from "styled-components";

//constants
import { ACCESSIBILITY_TEXTS } from "@core-ui/constants/Header";

interface CommonHeaderProps {
    children: ReactNode;
    onBack: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    containerClass?: string;
    isVisible: boolean;
    backButtonLocator?: string;
    dataTestId?: string;
    grayBackground?: boolean;
    marginTop?: number;
}

function BackButtonComponent(props: {
    onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    locator?: string;
    grayBackground?: boolean;
    marginTop?: number;
}): ReactElement {
    const theme = useTheme();
    return (
        <ContainerButton
            variant="primary"
            onClick={props.onClick}
            aria-label={ACCESSIBILITY_TEXTS.GO_BACK}
            data-testid={props.locator}
            grayBackground={props.grayBackground}
            marginTop={props.marginTop}
        >
            <BackIcon color={theme.colors[theme.colorMode].text_High_Emphasis} />
        </ContainerButton>
    );
}

const BackButton = React.memo(BackButtonComponent);

function CommonHeader(props: CommonHeaderProps): ReactElement | null {
    if (!props.isVisible) {
        return null;
    }

    return (
        <Container
            className={props.containerClass}
            data-testid={props.dataTestId}
            grayBackground={props.grayBackground}
        >
            <BackButton
                onClick={props.onBack}
                locator={props.backButtonLocator}
                grayBackground={props.grayBackground}
                marginTop={props.marginTop}
            />
            <ContainerContent grayBackground={props.grayBackground}>{props.children}</ContainerContent>
        </Container>
    );
}

export default memo(CommonHeader);
